import { render, staticRenderFns } from "./MomentList.vue?vue&type=template&id=b0d06678&scoped=true"
import script from "./MomentList.vue?vue&type=script&lang=js"
export * from "./MomentList.vue?vue&type=script&lang=js"
import style0 from "./MomentList.vue?vue&type=style&index=0&id=b0d06678&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d06678",
  null
  
)

export default component.exports